import React from "react"

import Layout from "../components/layout"
import ProfileImage from "../components/profile-image"
import SEO from "../components/seo"

const AboutPage = () => (
  <Layout>
    <SEO title="About" />
    <h1>About Adam Smyer</h1>
    <div
      style={{
        maxWidth: `480px`,
        paddingBottom: `0.5rem`,
        marginBottom: `1.45rem`,
      }}
    >
      <ProfileImage />
      <small>Photo by Ed Newman</small>
    </div>
    <p>
      ADAM SMYER is an attorney, martial artist, and mediocre bass player. His
      nonfiction appears in the{" "}
      <span style={{ fontStyle: `italic` }}>Johannesburg Review of Books</span>.
      Adam's debut novel,{" "}
      <span style={{ fontStyle: `italic` }}>Knucklehead</span> (Akashic Books),
      was the sole title shortlisted for the 2018 Ernest J. Gaines Award for
      Literary Excellence. His second book,{" "}
      <span style={{ fontStyle: `italic` }}>You Can Keep That to Yourself</span>{" "}
      (Akashic Books), was released in 2020;{" "}
      <span style={{ fontStyle: `italic` }}>Kirkus Reviews</span> called it "a
      bitingly humorous compendium of the absurd subtle racism of the American
      workplace". Adam lives in California with his wife and cats.
    </p>
  </Layout>
)

export default AboutPage
